module.exports = __webpack_public_path__ + "media/use-form/webinar@2x-7fd20b00.png";